import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#ededed",
        p: 2,
        textAlign: "center",
      }}
    >
      <Typography variant="body2" color="textSecondary">
        © {new Date().getFullYear()} Life Pro Nutrition - Todos los derechos reservados
      </Typography>
    </Box>
  );
};

export default Footer;
